import { StatCard } from '@skylabs-digital/backoffice-kit';
import { Activity, AlertTriangle, Clock, Gauge, Hourglass, Layers, Timer } from 'lucide-react';
import { formatDuration, formatRate } from '../../lib/format';
import type { ProcessingOverview } from '../../schemas/processing.schema';

const ETA_WARNING_SECONDS = 600;

export function ProcessingKpis({
  overview,
  loading,
}: {
  overview: ProcessingOverview | null;
  loading: boolean;
}) {
  const busy = loading && overview === null;
  const o = overview;
  const etaTone =
    o === null
      ? 'neutral'
      : !o.workerAlive
        ? 'danger'
        : (o.etaSeconds ?? 0) > ETA_WARNING_SECONDS
          ? 'warning'
          : 'success';
  const window = o?.window ?? '24h';
  return (
    <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-4 xl:grid-cols-7">
      <StatCard
        label="Queued"
        value={o?.backlog ?? '—'}
        icon={<Layers />}
        tone="info"
        loading={busy}
      />
      <StatCard
        label="Active"
        value={o?.queue.active ?? '—'}
        icon={<Activity />}
        tone="info"
        loading={busy}
      />
      <StatCard
        label="Throughput"
        value={o ? formatRate(o.throughputPerMin) : '—'}
        hint="last 10 minutes"
        icon={<Gauge />}
        loading={busy}
      />
      <StatCard
        label="ETA"
        value={
          o === null ? '—' : !o.workerAlive ? 'No worker consuming' : formatDuration(o.etaSeconds)
        }
        hint={o?.workerAlive && o.etaSeconds === null ? 'queue is empty' : undefined}
        icon={<Hourglass />}
        tone={etaTone}
        loading={busy}
      />
      <StatCard
        label="Avg wait"
        value={formatDuration(o?.avgWaitSeconds)}
        hint={`in ${window}`}
        icon={<Clock />}
        loading={busy}
      />
      <StatCard
        label="Avg work"
        value={formatDuration(o?.avgWorkSeconds)}
        hint={`in ${window}`}
        icon={<Timer />}
        loading={busy}
      />
      <StatCard
        label={`Failed (${window})`}
        value={o?.failedInWindow ?? '—'}
        icon={<AlertTriangle />}
        tone={o && o.failedInWindow > 0 ? 'danger' : 'neutral'}
        loading={busy}
      />
    </div>
  );
}
